/**
* Created by desheng.zhao on 2018/6/19.
*/
import Vue from 'vue';
import axios from 'axios';
import router from '../router/index'
import cookie from './cookie'
import md5 from 'vux/src/tools/md5/index.js'
import base64 from 'vux/src/tools/base64/index.js'

import conf from './../config/config'
import goUrl from './location'
import i18n from "./../lang/index"
import store from '../store'

const vm = new Vue;

const requestQueue = [];

/*使用自定义配置新建一个axios*/
const service = axios.create({
timeout: 60 * 1000
});

var timer = null; 


service.interceptors.request.use(config => {
if(!config.noLoading){
requestQueue.push(config.url);
}

var userCode = cookie.get(conf.userCode);
var lang = cookie.get("lang") || "zh-CN";

if(typeof userCode == 'string'){  //兼容用户名为邮箱
if(!userCode.includes('@')) {
if(userCode.length > 11) {
userCode = userCode.slice(-11);
}
}
}
let authParams = {
userId: cookie.get(conf.userId),
userCode: userCode,
accessToken: cookie.get(conf.tokenId)
};
let commonParam = {
streamNo: 'web_pss' + (new Date()).getTime() + parseInt(Math.random() * 1000000),
lang: lang
};
config.data = {
...config.data,
...commonParam
}
if(config.method.toLowerCase() === 'get') {
if(!config.noAuth){//不需要权限的不加权限信息
config.params = {
...config.data,
...authParams
}
}
config.params && Object.keys(config.params).forEach((val) => {
if(config.params[val] === '' || config.params[val] === undefined || config.params[val] === null) {
delete config.params[val]
}
})
delete config.data;
} else {
if(!config.noAuth){//不需要权限的不加权限信息
config.data = {
...config.data,
...authParams
}
}
config.data && Object.keys(config.data).forEach((val) => {
if(config.data[val] === '' || config.data[val] === undefined || config.data[val] === null) {
delete config.data[val]
}
})
}

if(requestQueue.length > 0){
Vue.$vux.loading.show({
text: '加载中'
});
}
return config;
}, error => {
console.log(error)
addError(error);
Promise.reject(error);
});


service.interceptors.response.use(
response => {
hideLoading(response.config.url);

var loginError = ['99999996','99999995','99999994','99999993','99999992','20000001',
"00000001","00000002","00000003","00000004","00000005","00000006","00000007","00000008"];// 登录信息异常的状态码
if(response.data && loginError.includes(response.data.resultCode)){

if(!timer){
timer = true;
const userAgent = window.navigator.userAgent;
if(/glocalMeCall/i.test(userAgent)){
appLogin();
}else{
login();
}
}
}else{
if(response.data.resultCode === "00000000"){
return response.data; 
}







return response.data; 
}
},
error => {

hideLoading(error.config.url);
addError(error);

Vue.$vux.toast.show({
type: "text",
text: i18n.t("common.networkError"), // "网络出错啦~",
position: "bottom"
});
return Promise.reject(error)
}
);


function hideLoading(url){
const index = requestQueue.indexOf(url);
index != -1 && requestQueue.splice(index, 1);
if(requestQueue.length === 0){
Vue.$vux.loading.hide();
}
}


function goToLogin() {
Vue.$vux.toast.show({
type: 'text',
text: i18n.t("common.tokenExpire"),//'登录信息已失效或未登录',
time: 2000,
position: 'bottom',
onHide: ()=>{
vm.$removeData();
router.push({
name: "login",
query: {
redirectUrl: router.currentRoute.name
}
});
}
});
}


function systemType() {
var u = window.navigator.userAgent;
var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; 
var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); 
if(isAndroid) {
return "Android";
}
if(isIOS) {
return "ios";
}
return "未知"
}

/*
* 在app內登錄信息過期重新登錄
* */
function appLogin() {
const system = systemType();

if(system == 'Android'){
try {
JsBridge.expireToRelogin();
} catch(err) {
Vue.$vux.toast.text(err.name + ":\n" + err.message,"bottom");
addError(err);
}
}else if(system == 'ios'){
try {
window.webkit.messageHandlers.expireToRelogin.postMessage({methodName: "expireToRelogin"});
} catch(err) {
Vue.$vux.toast.text(err.name + ":\n" + err.message,"bottom");
addError(err);
}
}else{
login();
}
}


async function login() {
var phone = localStorage.getItem("c");
if(phone == 'undefined'){
goToLogin();
return;
}
var password = localStorage.getItem("p");
if(password){
password = base64.decode(password);
}

if(phone && password){
var origin = location.origin || window.location.origin;

await axios.post(origin + conf.api.login,{
userCode: phone,
password: md5(password),
streamNo: 'web_pss' + (new Date()).getTime() + parseInt(Math.random() * 1000000)
}).then(res => {

if(res.data.resultCode == "00000000"){
vm.$saveData(res.data.data, phone, password);


var url = (location.origin || window.location.origin) + router.currentRoute.fullPath; 
goUrl(url);

}else{
goToLogin();
}
}).catch(err => {
addError(err);
goToLogin();
console.log(err);
}).finally(() => {
timer = null;
});
}else{
goToLogin();
}
}

function addError(err){
store.dispatch("addError",{
page: "ajax util",
error: err
});
}

export default service



// WEBPACK FOOTER //
// ./src/utils/ajax.js